import React, { memo } from 'react';
import PropTypes from 'prop-types';

import ActionsItem from '@/components/Pages/Product/ActionsItem';

import { ProductActionsList } from './Actions.styles';

function Actions({ actions = [] }) {
  return (
    <ProductActionsList>
      {actions.map(({ title, description }) => (
        <ActionsItem key={title} title={title} description={description} />
      ))}
    </ProductActionsList>
  );
}

Actions.propTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({ title: PropTypes.string, description: PropTypes.string })
      .isRequired
  ),
};

export default memo(Actions);
